'use strict';

import $ from 'jquery';
import 'select2';
import 'moment';
import 'daterangepicker';
import { userSubscribe } from '../../modules/userSubscribe';
import { groups } from '../../modules/select';

const index = {
  settings: {
    $selectState: $('.js-state-filter'),
    $selectCity: $('.js-cities'),
  },

  stateCity() {
    s.$selectState.select2({ theme: 'classic' }).on('change', function (e) {
      var post = {};
      post.id = e.target.value;
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/estados/busca-cidades/' + post.id;

      $.ajax({
        type: 'GET',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
      }).then(function (data) {
        s.$selectCity.empty();

        $.each(data, function (index, element) {
          var option = new Option(element, index);
          s.$selectCity.append(option);
        });
      });
    });

    s.$selectCity.select2({
      placeholder: 'Primeiro selecione seu estado',
      theme: 'classic',
      sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
    });
  },

  dateRange() {
    var prev_date = new Date();

    $('.js-date').daterangepicker({
      autoUpdateInput: false,
      locale: {
        format: 'DD/MM/YYYY',
        cancelLabel: 'Limpar',
        applyLabel: 'Aplicar',
        customRangeLabel: 'Custom',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
      },
    });

    $('.js-date').on('apply.daterangepicker', function (ev, picker) {
      $('input[name="filter[start_at]"]').val(picker.startDate.format('DD/MM/YYYY'));
      $('input[name="filter[end_at]"]').val(picker.endDate.format('DD/MM/YYYY'));
      $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
    });

    $('.js-date').on('cancel.daterangepicker', function (ev, picker) {
      $('input[name="filter[start_at]"]').val('');
      $('input[name="filter[end_at]"]').val('');
      $(this).val('');
    });
  },

  init() {
    _this.dateRange();
    _this.stateCity();

    groups();
    userSubscribe();
  },
};

const s = index.settings,
  _this = index;

export default _this;
